import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c7bbc8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "checked", "name", "disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control_indicator" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: "control control-checkbox",
    for: _ctx.id,
    "data-test": "checkbox"
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("input", {
      type: "checkbox",
      id: _ctx.id,
      checked: _ctx.value,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('modify', _ctx.name, $event.target.checked))),
      name: _ctx.name,
      disabled: _ctx.disabled
    }, null, 40, _hoisted_2),
    _hoisted_3
  ], 8, _hoisted_1))
}